import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import { PowerBIEmbed } from 'powerbi-client-react';

import { Loading } from '@components';
import { API } from '@service';

// import '@style/modules/analysis/powerbi.scss';
import '../../../../styles/modules/analysis/powerbi.scss';

const modalContainer = () => document.querySelector('.app-body');
const closeIcon = (
  <div className="powerbi-close-icon">
    <span className="appkiticon icon-left-chevron-fill a-font-12" />
    Back
  </div>
);

const setContainerPaddingLeft = (containerDom) => {
  if (!containerDom) {
    return;
  }

  const contentHeight = document.body.clientHeight + 64;
  //TODO move back button
  // const contentWidth = document.body.clientWidth;
  // const contentWidth = document.body.clientWidth + 64;
  // const paddingLeft = contentWidth - (contentHeight * (1440 - 102)) / 789;
  // containerDom.current.style.paddingLeft = `${paddingLeft}px`;
  containerDom.current.style.height = `100%`;
};

const PowerBIModal = ({ isModalVisible, toggleModalVisible, url }) => (
  <Modal
    getContainer={modalContainer}
    closeIcon={closeIcon}
    style={{ top: 0 }}
    footer={null}
    className="powerbi-embed-wrapper"
    visible={isModalVisible}
    onCancel={() => toggleModalVisible(false)}
  >
    <Content visible={isModalVisible} url={url} />
  </Modal>
);

export default function PowerBiLink({
  text = ' Access operational footprint complexities by country',
  url = '/powerBI',
}) {
  const [isModalVisible, toggleModalVisible] = useState(false);

  return (
    <div className="powerbi-wrapper">
      {/* <span className="appkiticon icon-link-outline" /> */}
      {/* <span className="powerbi-link" onClick={() => toggleModalVisible(true)}>
        {text}
      </span> */}
      <span style={{ height: '2.4rem', display: 'inline-block' }}> </span>
      <PowerBIModal
        isModalVisible={isModalVisible}
        toggleModalVisible={toggleModalVisible}
        url={url}
      />
    </div>
  );
}

export const PowerBILinkWithIcon = () => {
  const [isModalVisible, toggleModalVisible] = useState(false);

  return (
    <div className="link-icon-wrapper">
      <div className="link-icon" onClick={() => toggleModalVisible(true)}>
        <span className="appkiticon icon-link-outline" />
      </div>
      <PowerBIModal
        isModalVisible={isModalVisible}
        toggleModalVisible={toggleModalVisible}
      />
    </div>
  );
};

const Content = ({ visible, url = '/powerBI' }) => {
  const [isLoading, toggleLoading] = useState(false);
  const [embedComfig, changeConfig] = useState({});

  const containerRef = useRef(null);

  useEffect(() => {
    (async () => {
      toggleLoading(true);

      const result = await API.getPowerBiEmbedComfig(url);
      if (result?.status === 200) {
        changeConfig({
          accessToken: result.accessToken,
          ...result.embedUrl[0],
        });
      }

      toggleLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (Object.keys(embedComfig).length > 0) {
      setContainerPaddingLeft(containerRef);
    }
  }, [embedComfig]);

  if (isLoading) {
    return (
      <div className="loading" ref={containerRef}>
        Loading
      </div>
    );
  }

  return (
    <div ref={containerRef}>
      <PowerBIEmbed
        cssClassName="powerbi-embed"
        embedConfig={{
          type: 'report',
          tokenType: 1,
          ...embedComfig,
        }}
      />
    </div>
  );
};
